import type { Appearance } from '../../../style/external-theme/appearance/types';
/**
 * If the `headerLogo` property is missing (undefined) then we return true (for backwards compatibility)
 * otherwise we return the value in the session
 */
export const getHeaderLogoVisibility = (
  appearance: Appearance,
) => {
  const value = appearance.visibility?.headerLogo;

  return value === undefined ? true : value;
};

export const getHideApplicationLanguageSelector = (
  appearance: Appearance,
): boolean =>
  appearance?.visibility?.hideApplicationLanguageSelector ??
  false;
